module.exports = __webpack_public_path__ + "img/vr_icon.a8aa53bb.png";